import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  setLogindata,
  setUserdata,
} from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import { getUserLocation } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { formatIndianAmount, getAvgPricePerSqft } from "../Services/Helper";
import html2pdf from "html2pdf.js";
import LoginDialog from "../Common/LoginDialog";

const images = [
  "https://picsum.photos/id/1011/800/500",
  "https://picsum.photos/id/1012/800/500",
  "https://picsum.photos/id/1013/800/500",
  "https://picsum.photos/id/1015/800/500",
  "https://picsum.photos/id/1016/800/500",
];

const chipList = ["2BHK", "2.5BHK", "3BHK", "3.5BHK"];

function ProjectDetails() {
  const {
    logindata,
    setlogindata,
    setuserData,

    userData,
  } = useContext(ApiContext);

   const navigate = useNavigate();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const projectID = params.get("id");
  // const city = params.get("city");

  const [open, setOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);

   const [viewMobile, setviewMobile] = useState(false);

  const [projectDetails, setProjectDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [developerDetails, setDeveloperDetails] = useState(null);
  const [configDetails, setConfigDetails] = useState([]);
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    getProjectDetails(projectID);
    window.scrollTo(0, 0);
  }, []);

  const getProjectDetails = (id) => {
    getRecords(398, 1, `{SocietyID: { $in: [${id}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setProjectDetails(data?.response?.records[0] || null);
          getDeveloperDetails(data?.response?.records[0]?.DeveloperID);
          getConfigDetails(data?.response?.records[0]?.SocietyID);
          getProperties(data?.response?.records[0]?.SubAreaID);
          setLoading(false);
        } else {
          setLoading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const getDeveloperDetails = (devID) => {
    getRecords(417, 1, `{DeveloperID: { $in: [${devID}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setDeveloperDetails(data?.response?.records[0] || null);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getConfigDetails = (societyID) => {
    getRecords(
      416,
      10,
      `{SocietyID: { $in: [${societyID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setConfigDetails(data?.response?.records || []);
            setSelectedChip(data?.response?.records[0] || {});
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

  const getProperties = (SubAreaID) => {
    getRecords(
      384,
      50,
      `{SubAreaID: { $in: [${SubAreaID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setProperties(data?.response?.records || []);
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const sliderImages =
    typeof projectDetails?.Images === "string" && projectDetails.Images.trim()
      ? projectDetails.Images.split(",").map((i) => i.trim())
      : images || [];

  const totalImages = sliderImages.length;

  const mainSettings = {
    asNavFor: nav2,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const thumbSettings = {
    asNavFor: nav1,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: true,
    infinite: true,
    arrows: false,
  };
  const [selectedChip, setSelectedChip] = useState([]);

  const downloadBrochurePDF = () => {
    setLoading(true);
    const element = document.getElementById("brochure-page");

    const options = {
      margin: 0,
      filename: `${projectDetails?.Society || ""}_Brochure.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "landscape", // 👈 wider page
      },
    };

    html2pdf().set(options).from(element).save();
    setLoading(false);
  };

  return (
    <>
      {" "}
      <div className="page-wrapper">
        <Header />

        <div id="brochure-page">
          <div className="content-wrapper bg-seashell">
            {/* Breadcrumb Start */}
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="breadcrumb-title pt-10 pb-10">
                    <ul className="breadcrumb-menu list-style">
                      <li onClick={()=> navigate("/")} >Home</li>
                    <li onClick={() => navigate(-1)}>Projects</li>
                      <li>{projectDetails?.Society}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Breadcrumb End */}
            <div className="bg-seashell">
              <div position="relative">
                <Box
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    zIndex: 2,
                    background: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    padding: "4px 10px",
                    borderRadius: "12px",
                    fontSize: 14,
                  }}
                >
                  {activeIndex + 1} / {totalImages}
                </Box>

                {/* Main Slider */}
                <Slider {...mainSettings} ref={(s) => setNav1(s)}>
                  {sliderImages?.map((img, index) => (
                    <Box key={index}>
                      <div style={{background:'#101622'}}>    <img
                        src={img}
                        alt=""
                        style={{
                          width: "100%",
                          height: 480,
                          objectFit: "contain",
                          borderRadius: 0,
                        }}
                      /></div>
                  
                    </Box>
                  ))}
                </Slider>

                {/* Thumbnail Slider */}
                <Box className="thumbslider">
                  <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                    {sliderImages?.map((img, index) => (
                      <div key={index} px={0.5}>
                        <img
                          src={img}
                          alt=""
                          style={{
                            width: "100%",
                            height: 80,
                            objectFit: "cover",
                            borderRadius: 0,
                            cursor: "pointer",
                            border:
                              activeIndex === index
                                ? "2px solid #1976d2"
                                : "2px solid transparent",
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                  <div className="sliderchp">
                    <span>
                      <i class="ri-map-pin-line"></i> Highlights
                    </span>
                    <span>
                      <i class="ri-landscape-line"></i> Outdoors
                    </span>
                    <span>
                      <i class="ri-book-open-line"></i> Brochure
                    </span>
                    <span>
                      <i class="ri-video-line"></i> Videos
                    </span>
                    <span className="photos">
                      <i class="ri-gallery-line"></i> {totalImages} Photos
                    </span>
                  </div>
                </Box>
              </div>
              {/* <Box position="relative">
                        <Box
                          sx={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            zIndex: 2,
                            background: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: 14,
                          }}
                        >
                          {totalImages ? activeIndex + 1 : 0} / {totalImages}
                        </Box> */}

              {/* <Slider {...sliderSettings}>
                          {typeof projectDetails?.Images === "string" &&
                          projectDetails.Images.trim() !== ""
                            ? projectDetails.Images.split(",").map(
                                (img, index) => (
                                  <div key={index}>
                                    <img
                                      src={img.trim()}
                                      alt={`slide-${index}`}
                                      style={{
                                        width: "100%",
                                        height: "443px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </div>
                                )
                              )
                            : images?.map((img, index) => (
                                <div key={index}>
                                  <img
                                    src={img}
                                    alt={`slide-${index}`}
                                    style={{
                                      width: "100%",
                                      height: "280px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              ))}
                        </Slider> */}

              {/* View All Button */}
              {/* <div style={{ textAlign: "right", marginTop: -50 }}>
                          <Button
                            variant="outlined"
                            onClick={() => setOpen(true)}
                            className="vallimages"
                          >
                            View All Images
                          </Button>
                        </div> */}
            </div>
          </div>
          {projectDetails !== null && (
            <div
              className="content-wrapper bg-seashell"
              style={{ marginTop: 0 }}
            >
              <section className="property-details-wrap pb-50">
                <div className="container">
                  <div className="row gx-5">
                    <div className="col-xl-8">
                      <div className="property-details">
                        {/* <div className="card mb-30">
                      <Box position="relative">
                        <Box
                          sx={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            zIndex: 2,
                            background: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: 14,
                          }}
                        >
                          {totalImages ? activeIndex + 1 : 0} / {totalImages}
                        </Box>

                        <Slider {...sliderSettings}>
                          {typeof projectDetails?.Images === "string" &&
                          projectDetails.Images.trim() !== ""
                            ? projectDetails.Images.split(",").map(
                                (img, index) => (
                                  <div key={index}>
                                    <img
                                      src={img.trim()}
                                      alt={`slide-${index}`}
                                      style={{
                                        width: "100%",
                                        height: "280px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </div>
                                )
                              )
                            : images?.map((img, index) => (
                                <div key={index}>
                                  <img
                                    src={img}
                                    alt={`slide-${index}`}
                                    style={{
                                      width: "100%",
                                      height: "280px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              ))}
                        </Slider>

                     
                        <div style={{ textAlign: "right", marginTop: -50 }}>
                          <Button
                            variant="outlined"
                            onClick={() => setOpen(true)}
                            className="vallimages"
                          >
                            View All Images
                          </Button>
                        </div>
                      </Box>
                    </div> */}
                        <div className="card pd-20 mb-30">
                          <div class="property-title mb-0">
                            <div className="chipps chp">
                              {projectDetails?.RERAVerified === "Yes" && (
                                <span className="bg-green">RERA</span>
                              )}

                              <span className="bg-grey">No Brokerage</span>
                            </div>
                            <h2>{projectDetails.Society || ""}</h2>
                            {/* <p>{projectDetails.Developer || ""}</p> */}
                            <ul class="property-metainfo list-style">
                              <li>
                                <i class="flaticon-location"></i>
                                {projectDetails?.Locality || ""}
                              </li>
                            </ul>

                            <div className="chipps chp">
                              <span className="bg-red">
                                {projectDetails?.ProjectStatus || ""}
                              </span>
                              <span className="bg-green">
                                {projectDetails?.SocietyType || ""}
                              </span>

                              {projectDetails?.FeaturedID == 1 && (
                                <span className="bg-grey">{"Featured"}</span>
                              )}
                            </div>
                            <div className="border mt-30 mb-10"></div>
                            <h2>
                              ₹{projectDetails?.PriceRange || ""}{" "}
                              <small
                                style={{
                                  color: "grey",
                                  fontSize: 13,
                                  fontWeight: 400,
                                }}
                              >
                                + Charges
                              </small>
                            </h2>
                            <p className="fontnormal mb-0">PRICE RANGE</p>
                            <p
                              className="fontnormal mb-0"
                              style={{ color: "#000" }}
                            >
                              {configDetails
                                ?.map((chip) => chip.BHK.split(" ")[0])
                                .join(", ")}{" "}
                              BHK Apartments
                            </p>
                            <div className="header-btn d-block devv">
                              <button
                                onClick={() => {
                                  if (
                                    userData != null &&
                                    LoggedInUserID != null
                                  ) {
                                    downloadBrochurePDF();
                                  } else {
                                    setOpenLogin(true);
                                  }
                                }}
                                type="button"
                                className="btn style1"
                              >
                                <i class="ri-download-2-line"></i> Download
                                Brochure
                              </button>
                            </div>

                            {/*                         
                        <div className="chipps">
                          <span className="property-condo">
                            {projectDetails?.ProjectStatus || ""}
                          </span>
                          {projectDetails?.RERAVerified === "Yes" && (
                            <span className="property-status">
                              Rera Verified
                            </span>
                          )}
                        </div> */}

                            {/* <span>Unit Options</span>
                        <div className="chips-container">
                          {configDetails?.map((chip) => (
                            <button
                              key={chip.SocietyConfigID}
                              className={`chip ${
                                selectedChip.SocietyConfigID ===
                                chip.SocietyConfigID
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => setSelectedChip(chip)}
                            >
                              {chip.BHK}
                            </button>
                          ))}
                        </div> */}
                          </div>
                        </div>
                        {/* <div className="card pd-20 mb-30">
                      <h5>Pricing & Area</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style">
                          <li>
                            <span>Price Range</span> ₹
                            {formatIndianAmount(selectedChip?.Price) || ""}
                          </li>
                          <li>
                            <span>Carpet Area</span>{" "}
                            {selectedChip?.CarpetArea || ""}{" "}
                            {selectedChip?.UOMName || ""}
                          </li>
                        
                        </ul>
                        <p>
                          Configuration:{" "}
                          {configDetails?.map((item) => item.BHK).join(", ")}
                        </p>
                        <small>*Price excludes stamp duty & registration</small>
                      </div>
                    </div> */}

                        <div className="card pd-20 mb-30">
                          <h5>Available Configurations</h5>

                          <div className="row">
                            <Slider {...sliderSettings} className="bhkslider">
                              {configDetails?.map((config, i) => (
                                <div
                                  onClick={() => setSelectedChip(config)}
                                  key={i}
                                  className="col-md-6"
                                >
                                  <div
                                    style={{
                                      backgroundColor:
                                        selectedChip?.SocietyConfigID !==
                                        config?.SocietyConfigID
                                          ? "transparent"
                                          : "#eaf8f0",
                                    }}
                                    className="p-20 borderr"
                                  >
                                    <h6 className="mb-0">{config.BHK}</h6>
                                    <small className="d-block mb-10 greyy">
                                      Apartment
                                    </small>

                                    <small className="greyy d-block">
                                      Carpet Area
                                    </small>
                                    <span className="d-block">
                                      {config.CarpetArea} {config.UOMName}
                                    </span>
                                    {/* <small className="d-block greyy mb-20">
                                (153.65 - 163.04 sqm)
                              </small> */}
                                    <small className="greyy d-block">
                                      Built Up Area Area
                                    </small>
                                    <span className="d-block">
                                      {config.BuiltUpArea} {config.UOMName}
                                    </span>
                                    <h5 className="mb-0">
                                      {formatIndianAmount(config?.Price)}{" "}
                                      <small
                                        style={{
                                          color: "grey",
                                          fontSize: 13,
                                          fontWeight: 400,
                                        }}
                                      >
                                        + Charges
                                      </small>
                                    </h5>
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30">
                          <h5>Project Overview</h5>
                          <div class="property-desc">
                            <p style={{ fontSize: 16 }}>
                              {projectDetails?.ProjectOverview || ""}
                            </p>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30">
                          <h5>More About {projectDetails?.Society || ""}</h5>
                          <div class="property-desc">
                            <p style={{ fontSize: 16 }}>
                              {projectDetails?.MoreAboutProject || ""}
                            </p>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30 quickfacts">
                          <h5>Project Details</h5>
                          <div class="property-desc">
                            <ul class="property-features list-style facts">
                              <li className="">
                                <small>
                                  <i className="flaticon-square"></i>
                                </small>
                                <div>
                                  Project Area
                                  <b>
                                    {projectDetails?.ProjectArea}{" "}
                                    {projectDetails?.Area}
                                  </b>
                                </div>
                              </li>
                              <li className="">
                                <small>
                                  <i className="ri-ruler-line"></i>
                                </small>
                                <div>
                                  Sizes
                                  <b> {projectDetails?.AreaRange || ""}</b>
                                </div>
                              </li>

                              <li className="">
                                <small>
                                  <i className="ri-building-3-line"></i>
                                </small>
                                <div>
                                  Project Size
                                  <b> {projectDetails?.ProjectSize || ""}</b>
                                </div>
                              </li>
                              <li className="">
                                <small>
                                  <i className="ri-calendar-2-line"></i>
                                </small>
                                <div>
                                  Launch Date
                                  <b> {projectDetails?.LaunchDate || ""}</b>
                                </div>
                              </li>

                              {/* <li className="">
                            <small>
                              <i className="ri-money-rupee-circle-line"></i>Avg
                              Price
                            </small>
                            ₹
                            {formatIndianAmount(
                              configDetails?.length
                                ? (() => {
                                    const prices = configDetails
                                      .map((item) => item?.Price)
                                      .filter((price) => price != null);

                                    return prices.length
                                      ? prices?.reduce((sum, p) => sum + p, 0) /
                                          prices.length
                                      : 0;
                                  })()
                                : 0
                            )}
                          </li> */}
                              <li className="">
                                <small>
                                  <i className="ri-folder-keyhole-line"></i>
                                </small>
                                <div>
                                  Possession
                                  <b>{projectDetails?.ProjectStatus || ""}</b>
                                </div>
                              </li>
                              <li className="">
                                <small>
                                  <i className="ri-shield-check-line"></i>
                                </small>
                                <div>
                                  RERA ID
                                  <b> {projectDetails?.RERAID || ""}</b>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30 amenities newam">
                          <h5>Amenities</h5>
                          <div class="property-desc">
                            <div className="row d-flex df">
                              {projectDetails?.PropertyAmenities?.length > 0 &&
                                projectDetails.PropertyAmenities.map(
                                  (amenity) => (
                                    <div
                                      key={amenity?.PropertyAmenitiesID}
                                      className="property-card style3"
                                    >
                                      <div className="property-info">
                                        <div className="">
                                          <img
                                            src={
                                              amenity?.PropertyAmenitiesIcon ||
                                              "/assets/icons/default-amenity.png"
                                            }
                                            alt={
                                              amenity?.PropertyAmenities ||
                                              "amenity"
                                            }
                                            className="amenity-icon"
                                          />
                                        </div>
                                        <p>{amenity?.PropertyAmenities}</p>
                                      </div>
                                    </div>
                                  ),
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30">
                          <h5>Nearby Locations</h5>
                          <div class="property-desc">
                            <div className="row d-flex df">
                              <ul className="nearby">
                                <li>
                                  <i className="ri-hospital-line"></i> Hospital:
                                  Yatharth Super Speciality Hospital
                                </li>
                                <li>
                                  <i className="ri-store-2-line"></i> Market:
                                  Jagat Farm Market
                                </li>
                                <li>
                                  <i className="ri-school-line"></i> School:
                                  Delhi Public School (DPS)
                                </li>
                                <li>
                                  <i className="ri-plane-line"></i> Airport:
                                  Indira Gandhi International
                                </li>
                                <li>
                                  <i className="ri-train-line"></i> Railway:
                                  Dadri Railway Station
                                </li>
                                <li>
                                  <i className="ri-subway-line"></i> Metro:
                                  Noida Sector 51 (Aqua Line)
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30">
                          <h5>Floor Plans</h5>

                          <div
                            class="property-desc bg-seashell pd-20"
                            style={{ borderRadius: 6 }}
                          >
                            <ul class="property-features list-style mb-0">
                              <li>
                                <div>
                                  {selectedChip?.BHK || ""}
                                  <small
                                    style={{ fontWeight: 800, color: "#000" }}
                                  >
                                    {selectedChip?.Bedrooms} Bed •{" "}
                                    {selectedChip?.Bathrooms} Bath
                                  </small>

                                  <small>
                                    Carpet Area: {selectedChip?.CarpetArea}{" "}
                                    {selectedChip?.UOMName}
                                  </small>
                                </div>
                                <div>
                                  <small>Price</small>
                                  <div
                                    style={{
                                      color: "#0d9488",
                                      fontWeight: 600,
                                    }}
                                  >
                                    ₹
                                    {formatIndianAmount(
                                      selectedChip?.Price || 0,
                                    )}
                                  </div>
                                </div>
                              </li>
                            </ul>
                            <div className="carpetblock mb-20">
                              <div className="carpet">
                                <img
                                  src={
                                    selectedChip?.FloorPlanImage ||
                                    "../assets/img/carpet.jpg"
                                  }
                                  alt="Image"
                                />
                              </div>
                            </div>

                            {/* <ul class="property-features list-style">
                          <li>
                            <div style={{ width: "50%", textAlign: "left" }}>
                              <small>Carpet Area</small>
                              {selectedChip?.CarpetArea || 0}{" "}
                              {selectedChip?.UOMName || ""}
                            </div>

                            <div style={{ width: "50%", textAlign: "left" }}>
                              <small>Built-up Area</small>
                              {selectedChip?.BuiltUpArea || 0}{" "}
                              {selectedChip?.UOMName || ""}
                            </div>
                          </li>
                        </ul> */}
                            <div className="header-btn hbtns alignbtn">
                              <button
                                type="button"
                                className="btn style3 loginbtn"
                                style={{ marginRight: 10, background: "#fff" }}
                              >
                                Download Plan
                              </button>
                              <button type="button" className="btn style1">
                                Get Quote
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="card pd-20 mb-30 amenities">
                          <h5>Location</h5>
                          <div class="property-desc">
                            <div className="map">
                              {projectDetails?.Coordinate && (
                                <iframe
                                  src={`https://www.google.com/maps?q=${projectDetails?.Coordinate[0]},${projectDetails?.Coordinate[1]}&hl=en&z=15&output=embed`}
                                  width="100%"
                                  height="250"
                                  loading="lazy"
                                  referrerPolicy="no-referrer-when-downgrade"
                                />
                              )}
                            </div>
                            {/* <p>Nearby Places</p>

                        <div class="property-desc">
                          <ul class="property-features list-style lst">
                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Whitefield Railway Station
                              </span>{" "}
                              <span>
                                2.5 km <small>8 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Phoenix MarketCity
                              </span>{" "}
                              <span>
                                3.5 km
                                <small>12 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>
                                Columbia Asia Hospital
                              </span>{" "}
                              <span>
                                1.5 km
                                <small>6 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Ryan International School
                              </span>{" "}
                              <span>
                                2.1 km <small>7 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Whitefield Railway Station
                              </span>{" "}
                              <span>
                                2.5 km<small>8 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Varthur Lake
                              </span>{" "}
                              <span>
                                1.2 km <small>4 min</small>
                              </span>
                            </li>
                          </ul>
                        </div> */}
                          </div>
                        </div>

                        <div className="card pd-20 mb-30 amenities">
                          <h5>Customer Reviews</h5>
                          <div class="property-desc mb-0">
                            <div className="creview">
                              <div className="d-flex">
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                              </div>
                              <p>
                                "Excellent project with great amenities. The
                                location is perfect and the construction quality
                                is top-notch. Highly recommended for families
                                looking for a peaceful living environment."
                              </p>

                              <div className="d-flex">
                                <div className="dev">
                                  <div className="developer">
                                    <img
                                      src="assets/img/clients/client-1.jpg"
                                      alt="Image"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <span>
                                    <b>Rajesh Kumar</b>
                                  </span>
                                  <small>Property Owner</small>
                                </div>
                              </div>
                            </div>

                            <div className="creview">
                              <div className="d-flex">
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                              </div>
                              <p>
                                "Excellent project with great amenities. The
                                location is perfect and the construction quality
                                is top-notch. Highly recommended for families
                                looking for a peaceful living environment."
                              </p>

                              <div className="d-flex">
                                <div className="dev">
                                  <div className="developer">
                                    <img
                                      src="assets/img/clients/client-1.jpg"
                                      alt="Image"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <span>
                                    <b>Rajesh Kumar</b>
                                  </span>
                                  <small>Property Owner</small>
                                </div>
                              </div>
                            </div>

                            <div className="creview">
                              <div className="d-flex">
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                              </div>
                              <p>
                                "Excellent project with great amenities. The
                                location is perfect and the construction quality
                                is top-notch. Highly recommended for families
                                looking for a peaceful living environment."
                              </p>

                              <div className="d-flex">
                                <div className="dev">
                                  <div className="developer">
                                    <img
                                      src="assets/img/clients/client-1.jpg"
                                      alt="Image"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <span>
                                    <b>Rajesh Kumar</b>
                                  </span>
                                  <small>Property Owner</small>
                                </div>
                              </div>
                            </div>

                            <div className="creview">
                              <div className="d-flex">
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                              </div>
                              <p>
                                "Excellent project with great amenities. The
                                location is perfect and the construction quality
                                is top-notch. Highly recommended for families
                                looking for a peaceful living environment."
                              </p>

                              <div className="d-flex">
                                <div className="dev">
                                  <div className="developer">
                                    <img
                                      src="assets/img/clients/client-1.jpg"
                                      alt="Image"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <span>
                                    <b>Rajesh Kumar</b>
                                  </span>
                                  <small>Property Owner</small>
                                </div>
                              </div>
                            </div>

                            <div className="creview">
                              <div className="d-flex">
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                              </div>
                              <p>
                                "Excellent project with great amenities. The
                                location is perfect and the construction quality
                                is top-notch. Highly recommended for families
                                looking for a peaceful living environment."
                              </p>

                              <div className="d-flex">
                                <div className="dev">
                                  <div className="developer">
                                    <img
                                      src="assets/img/clients/client-1.jpg"
                                      alt="Image"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <span>
                                    <b>Rajesh Kumar</b>
                                  </span>
                                  <small>Property Owner</small>
                                </div>
                              </div>
                            </div>

                            <div className="creview">
                              <div className="d-flex">
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                                <i className="ri-star-fill"></i>
                              </div>
                              <p>
                                "Excellent project with great amenities. The
                                location is perfect and the construction quality
                                is top-notch. Highly recommended for families
                                looking for a peaceful living environment."
                              </p>

                              <div className="d-flex">
                                <div className="dev">
                                  <div className="developer">
                                    <img
                                      src="assets/img/clients/client-1.jpg"
                                      alt="Image"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <span>
                                    <b>Rajesh Kumar</b>
                                  </span>
                                  <small>Property Owner</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className="property-details pddetails">
                        <div className="card pd-20 mb-30">
                          <div class="property-title mb-0">
                            <div className="d-flex">
                              <div className="dev">
                                <div className="developer dep" style={{background:'#0d9488'}}>
                                  <i className="ri-building-line" style={{ color:'#fff'}}></i>
                                </div>
                              </div>
                              <div>
                                <small className="d-block">DEVELOPED BY</small>
                                <span>
                                  <b>
                                    {projectDetails?.DeveloperName || "N/A"}
                                  </b>
                                </span>
                              </div>
                            </div>

                            {/* <h5>Contact Developer</h5>
                        <span>Developer</span>
                        <p>{projectDetails?.DeveloperName || "N/A"}</p> */}

                            <div className="header-btn d-block devv dline">
                              <button
                                style={{ borderRadius: 20 }}
                                onClick={() => {
                                  if (
                                    userData != null &&
                                    LoggedInUserID != null
                                  ) {
                                      setviewMobile(!viewMobile);
                                  } else {
                                    setOpenLogin(true);
                                  }
                                }}
                                type="button"
                                className="btn style1"
                              >
                                <i class="ri-phone-line"></i> {viewMobile ? developerDetails?.ContactNumber : "Call Now"}
                              </button>

                              <button
                                style={{ borderRadius: 20 }}
                                onClick={() => {
                                  if (
                                    userData != null &&
                                    LoggedInUserID != null
                                  ) {
                                  } else {
                                    setOpenLogin(true);
                                  }
                                }}
                                type="button"
                                className="btn style3 loginbtn"
                              >
                                {" "}
                                Get Callback{" "}
                              </button>
                            </div>
                          </div>
                        </div>

                        {/*                     
                    <div className="card pd-20 mb-30">
                      <h5>EMI Calculator</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style ltype">
                          <li>
                            <span>Loan Amount</span> <span>₹60 Lakhs</span>
                          </li>

                          <li>
                            <span>Interest Rate</span>{" "}
                            <span>8.5% p.a.</span>{" "}
                          </li>
                          <li>
                            <span>Tenure</span> <span>20 Years</span>{" "}
                          </li>
                        </ul>
                        <ul
                          class="property-features list-style lst mb-0 pd-0 ltype tyle"
                          style={{ paddingBottom: 0 }}
                        >
                          <li
                            style={{
                              borderBottom: "1px solid #fff !important",
                              marginBottom: 0,
                              paddingBottom: 0,
                            }}
                          >
                            <span>Monthly EMI</span>{" "}
                            <span className="prce">₹51,745</span>{" "}
                          </li>
                        </ul>

                        <div className="header-btn d-block devv dline">
                          <button type="button" className="btn style3 loginbtn">
                            Calculate EMI
                          </button>
                        </div>
                      </div>
                    </div> */}

                        <div className="card pd-20 mb-30">
                          <h5>Price Summary</h5>
                          <div class="property-desc">
                            <ul class="property-features list-style ltype">
                              <li>
                                <span>Unit Type</span>{" "}
                                <span>{selectedChip?.BHK}</span>
                              </li>

                              <li>
                                <span>Price Range</span>{" "}
                                <span>
                                  ₹{formatIndianAmount(selectedChip?.Price)}
                                </span>{" "}
                              </li>
                              <li>
                                <span>Carpet Area</span>{" "}
                                <span>
                                  {selectedChip?.CarpetArea}{" "}
                                  {selectedChip?.UOMName}
                                </span>{" "}
                              </li>
                            </ul>
                            <ul
                              class="property-features list-style lst mb-0 pd-0 ltype tyle"
                              style={{ paddingBottom: 0 }}
                            >
                              <li
                                style={{
                                  borderBottom: "1px solid #fff !important",
                                  marginBottom: 0,
                                  paddingBottom: 0,
                                }}
                              >
                                <span>
                                  Avg. Price/sq.ft{selectedChip?.UOMName}
                                </span>{" "}
                                <span className="prce">
                                  ₹{getAvgPricePerSqft(selectedChip)}
                                </span>{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          )}
        </div>

        <LoginDialog
          open={openLogin}
          onClose={() => setOpenLogin(false)}
          onSuccess={(data) => {
            if (data) {
              //  console.log("Login Success:", data);
              setLogindata(data);
              setlogindata(data);

              localStorage.setItem("loginData", JSON.stringify(data));
            }

            //  setUser(data);
          }}
          onUserDetails={(userDetails) => {
            if (userDetails) {
              // console.log("User Details:", userDetails);
              setUserdata(userDetails);
              setuserData(userDetails);
              localStorage.setItem("UserData", JSON.stringify(userDetails));
            }
          }}
        />

        {/* Gallery Dialog */}
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <IconButton
            onClick={() => setOpen(false)}
            style={{ position: "absolute", right: 8, top: -3, zIndex: 9999 }}
          >
            x
          </IconButton>

          <DialogContent style={{ padding: 0, overflowY: "clip" }}>
            <Box position="relative">
              <Box
                sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  zIndex: 2,
                  background: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: 14,
                }}
              >
                {activeIndex + 1} / {totalImages}
              </Box>

              {/* Main Slider */}
              <Slider {...mainSettings} ref={(s) => setNav1(s)}>
                {sliderImages?.map((img, index) => (
                  <Box key={index}>
                    <img
                      src={img}
                      alt=""
                      style={{
                        width: "100%",
                        height: 400,
                        objectFit: "cover",
                        borderRadius: 0,
                      }}
                    />
                  </Box>
                ))}
              </Slider>

              {/* Thumbnail Slider */}
              <Box mt={2}>
                <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                  {sliderImages?.map((img, index) => (
                    <Box key={index} px={0.5}>
                      <img
                        src={img}
                        alt=""
                        style={{
                          width: "100%",
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 0,
                          cursor: "pointer",
                          border:
                            activeIndex === index
                              ? "2px solid #1976d2"
                              : "2px solid transparent",
                        }}
                      />
                    </Box>
                  ))}
                </Slider>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        <Footer />

        <div className="fixedbuttns">
          <button
            onClick={() => {
              if (userData != null && LoggedInUserID != null) {
                downloadBrochurePDF();
              } else {
                setOpenLogin(true);
              }
            }}
            type="button"
            className="btn style1 btnn1"
          >
            <i class="ri-download-line text-lg"></i> Brochure
          </button>
          <button
            onClick={() => {
              if (userData != null && LoggedInUserID != null) {

                setviewMobile(!viewMobile);
                


              } else {
                setOpenLogin(true);
              }
            }}
            type="button"
            className="btn style1 btnn2"
          >
            <i class="ri-phone-line text-lg"></i> {viewMobile ? developerDetails?.ContactNumber : "View Number"}
          </button>
          <button type="button" className="btn btnn3">
            <i class="ri-heart-line"></i> Save
          </button>
        </div>
      </div>
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </>
  );
}

export default ProjectDetails;
